<template>
  <table class="site-profile-users">
    <thead>
      <tr>
        <th>{{ $t('settings.siteUser') }}</th>
        <th>{{ $t('status.name') }}</th>
        <th>{{ $t('lastLogin') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr class="site-profile-users-table-filters">
        <td>
          <input
            type="text"
            v-model="filterUser"
          >
        </td>
        <td class="settings-filter">
          <HKLSelect
            :value="filterStatus"
            class="align-center"
            settings-filter-row
            :options="userStatusHklOptions"
            :showSearch="false"
            placeholder=""
            @change="val => { filterStatus = val }"
          />
        </td>
        <td>
          <!-- <input type="text" v-model="filterLastLoginAt" /> -->
        </td>
      </tr>
      <tr
        v-for="(item, index) in orderedUsers"
        :key="index"
      >
        <td>
          <span>{{ userName(item) }}</span>
          <i
            class="fa fa-ban"
            aria-hidden="true"
            v-if="!item.enabled"
          />
        </td>
        <td>
          <span>{{ showStatus(item) }}</span>
        </td>
        <td>
          <span>{{ formatDate(item.lastLoginAt) }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import _ from 'lodash'
import dateUtil from '@/utils/dateUtil'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import userHelper from '@/utils/userHelper'
import { userStatusMapping, userStatusAllOptions } from '@/utils/locale'

export default {
  name: 'SiteProfileUsers',
  components: {
    HKLSelect,
  },
  props: {
    users: {
      type: Array,
      default: [],
    },
  },
  data () {
    return {
      filterUser: '',
      filterLastLoginAt: '',
      userStatusAllOptions,
      filterStatus: userStatusAllOptions[0],
    }
  },
  computed: {
    userStatusHklOptions () {
      return this.userStatusAllOptions.map((value) => ({
        name: this.$options.filters.customStatusLabel(value),
        value,
      }))
    },
    orderedUsers () {
      const statusFiter = item => !this.filterStatus ||
            this.filterStatus === this.userStatusAllOptions[0] ||
            (this.filterStatus === userStatusMapping[item.enabled])

      const filterUser = this.filterUser.toLowerCase()
      const nameFilter = item => item.username.split('@')[0].toLowerCase().indexOf(filterUser) !== -1 ||
          (item.displayName || '').toLowerCase().indexOf(filterUser) !== -1

      const filterLastLoginAt = this.filterLastLoginAt.trim().toLowerCase()
      const lastLoginFilter = item => !filterLastLoginAt ||
        this.formatDate(item.lastLoginAt).toLowerCase().indexOf(filterLastLoginAt) !== -1

      const filter = item => statusFiter(item) && nameFilter(item) && lastLoginFilter(item)

      const filteredResult = _.filter(this.users, filter)
      return _.orderBy(filteredResult, this.orderbyAttr)
    },
  },
  methods: {
    showStatus (user) {
      return this.$options.filters.showStatusLabel(user.enabled)
    },
    userName (user) {
      if (user.username) {
        const name = userHelper.getUserName(user.username, user.displayName)
        return name
      }
    },
    formatDate (dateString) {
      return dateUtil.formatDate(dateString, true)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings/style';

.site-profile-users {
  ::v-deep .hkl-select {
    max-width: none;
  }

  .site-profile-users-table-filters {
    input {
      min-width: 100%;
    }
  }
}
</style>
